import TrackingPageAccessCard from '@/components/TrackingPageAccessCard';

const OrderLookup = () => <TrackingPageAccessCard showManual />;

export default OrderLookup;
